const ACCESTOKENS = {
    listTokens: "Token list",
    newTokens: "Create Token",
    user: "User",
    token: "Token",
    dateExpired: "F. Expiration",
    company: "Company",
    acctions: "Actions",

    "delete": "Delete",
    edit: "Edit",
    accept: "Accept",
    cancel: "Cancel",
    update: "Update",

    titleAlert: "Delete token",
    messageAlert: "Do you want to delete the token?",

    searchUser: "Search user...",
    users: "Users",
    created: "Created",
    Email: "E-mail",

    dateEspirated: "Expiration date",
    phone: "Telephone",
    Role: "Role",
    createToken: "Create Token",
    new: "New",

    emptyTokens: "There are no registered tokens.",
    listTokens: "Token list",
    dateEpiredCompany1: `The company's hire date**`,
    dateEpiredCompany2: `** has expired, you must update it.`,

    tokenIsUpdated: "Token has been updated",
    errorToUpdate: "Failed to update",
    CanNotUpdate: "Failed to refresh token.",
    selectedUser: "Select a user",

    tooltip: {
        all: "All",
        active: "Active",
        expired: "Expired"
    }


}

export default { ACCESTOKENS };